{
  "loading": "Загружаем…",
  "language": {
    "switch": "Язык интерфейса"
  },
  "theme": {
    "light": "Светлая тема",
    "dark": "Тёмная тема"
  },
  "status": {
    "up": "Работает",
    "down": "Не работает",
    "warn": "Частично",
    "unknown": "Неизвестно"
  },
  "action": {
    "logout": "Выйти",
    "close": "Закрыть",
    "cancel": "Отмена",
    "save": "Сохранить",
    "delete": "Удалить",
    "add": "Добавить",
    "apply": "Применить",
    "retry": "Повторить",
    "refresh": "Обновить",
    "copy": "Копировать",
    "copied": "Скопировано",
    "showDetails": "Показать подробности",
    "hideDetails": "Скрыть подробности",
    "expand": "Развернуть",
    "collapse": "Свернуть",
    "showPassword": "Показать пароль",
    "hidePassword": "Скрыть пароль",
    "sortBy": "Сортировать по «{{column}}»"
  },
  "bytes": {
    "b": "{{value, number}} Б",
    "kb": "{{value, number}} КБ",
    "mb": "{{value, number}} МБ",
    "gb": "{{value, number}} ГБ"
  },
  "ago": {
    "justNow": "только что",
    "seconds_one": "{{count}} с назад",
    "seconds_few": "{{count}} с назад",
    "seconds_many": "{{count}} с назад",
    "seconds_other": "{{count}} с назад",
    "minutes_one": "{{count}} мин назад",
    "minutes_few": "{{count}} мин назад",
    "minutes_many": "{{count}} мин назад",
    "minutes_other": "{{count}} мин назад",
    "hours_one": "{{count}} ч назад",
    "hours_few": "{{count}} ч назад",
    "hours_many": "{{count}} ч назад",
    "hours_other": "{{count}} ч назад",
    "days_one": "{{count}} сут назад",
    "days_few": "{{count}} сут назад",
    "days_many": "{{count}} сут назад",
    "days_other": "{{count}} сут назад"
  },
  "count": {
    "nodes_one": "{{count}} узел",
    "nodes_few": "{{count}} узла",
    "nodes_many": "{{count}} узлов",
    "nodes_other": "{{count}} узла",
    "frames_one": "{{count}} рамка",
    "frames_few": "{{count}} рамки",
    "frames_many": "{{count}} рамок",
    "frames_other": "{{count}} рамки",
    "checks_one": "{{count}} проверка",
    "checks_few": "{{count}} проверки",
    "checks_many": "{{count}} проверок",
    "checks_other": "{{count}} проверки",
    "permissions_one": "{{count}} право",
    "permissions_few": "{{count}} права",
    "permissions_many": "{{count}} прав",
    "permissions_other": "{{count}} права",
    "records_one": "{{count}} запись",
    "records_few": "{{count}} записи",
    "records_many": "{{count}} записей",
    "records_other": "{{count}} записи"
  },
  "dash": "—",
  "restoringSession": "Восстанавливаем сессию…",
  "loadingProfile": "Загружаем профиль…",
  "loadingSection": "Загружаем раздел…"
}
